
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about/membership/member-relations-team",
      function () {
        return require("private-next-pages/about/membership/member-relations-team/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about/membership/member-relations-team"])
      });
    }
  